<template>
  <div>
     <print-preview-browser :hideCloseButton="true"/>
  </div>
</template>
<script>
import { mapActions } from "vuex";
import printPreviewBrowser from "../components/print/PrintPreviewBrowser";

export default {
  name: "printImages",
  components: {
    printPreviewBrowser
  },
  methods: {
    ...mapActions(["appPrintSetup"])
  },
  mounted() {
    let query = this.$route.query;
    this.appPrintSetup(query);
  }
};
</script>

<style lang="scss" scoped>
.image-browser-test-page {
  padding: 0;
}
</style>